// export function isValidIMEI(imei: string): boolean {
//     // Remove any non-digit characters from the input
//     imei = imei.replace(/\D/g, '')

//     // Check if the IMEI is exactly 15 digits long
//     if (imei.length !== 15) {
//         return false
//     }

//     let sum = 0
//     let shouldDouble = false

//     // Loop through the digits from right to left
//     for (let i = imei.length - 1 i >= 0 i--) {
//         let digit = parseInt(imei.charAt(i), 10)

//         if (shouldDouble) {
//             digit *= 2
//             // If doubling the digit results in a number greater than 9, subtract 9
//             if (digit > 9) {
//                 digit -= 9
//             }
//         }

//         // Add the digit (or adjusted value) to the sum
//         sum += digit

//         // Alternate the doubling flag
//         shouldDouble = !shouldDouble
//     }

//     // Check if the sum is divisible by 10
//     return sum % 10 === 0
// }

// Helper function to validate IMEI using Luhn Algorithm
export const isValidIMEI = (imei: string): boolean => {
  if (!/^[0-9]{15}$/.test(imei)) return false // Check if it matches the basic pattern
  let sum = 0
  for (let i = 0; i < 15; i++) {
    let digit = parseInt(imei[i])
    if (i % 2 === 1) { // Double every second digit (0-based index)
      digit *= 2
      if (digit > 9) digit -= 9 // Subtract 9 if the doubled value is greater than 9
    }
    sum += digit
  }
  return sum % 10 === 0 // Valid if the sum modulo 10 is 0
}